export const EYE_BOT_PRESCRIPTION_ID = 'eyebotrx00001'

export const EYEBOT_RX_ITEM_INFO = {
  productName: 'Vision Prescription',
  imgSrc: '/img/eyebot/file-prescription.png',
}
